import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import * as BasketNS from '@emersya/mpa-basket';
import {InputButton} from '@emersya/mpa-components';

export interface IProductTileComponentConfiguration extends InputButton.Configuration {
	SKU: string;
	viewerCode: string;
	iconURL: string;
	basketProduct: BasketNS.Product;
};

export class ProductTileComponent extends InputButton.Component {
	static override getInputEventSubType() {
		const parentClass = <typeof CM.Component><any>STD.object.getParentClassFromClass(this);
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button', {});
		}
		return parentClass.type;
	};

	basketProduct: object;

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IProductTileComponentConfiguration
	) {
		super(descriptor, configuration);
		this.basketProduct = configuration.basketProduct;
		this.component_DOM.classList.add('thick');
	};
};
export namespace NS {
	export const Component = ProductTileComponent;
	export type Component = ProductTileComponent;
	export type Configuration = IProductTileComponentConfiguration;
}
import manifestXMLSource from './ProductTile.xml';
import './ProductTile.scss';

CM.Manager.declare({
	id: 'product-tile',
	type: ProductTileComponent,
	manifest: manifestXMLSource
});
